class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.clearText = this.querySelector('.nav-search-clearText')
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.emptySearch = this.querySelector('#empty_search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 100).bind(this));

    this.clearText.addEventListener('click', () => {
      this.input.value = "";
      this.predictiveSearchResults.innerHTML = ``;
    })

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        this.onEnterPressed(event);
      }
    });
  }

  async onChange() {
    this.predictiveSearchResults.innerHTML = ``;
    this.searchHistory = [];
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    await this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {


    try {
          const response = await fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,article&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`);
          
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            console.log("NO RESULTS")
            throw error;
          }

          const suggestions = await response.json();        
          suggestions.resources.results.collections = await this.searchCollections(searchTerm);
          suggestions.resources.results.pages = await this.searchPages(searchTerm);

          if(searchTerm.length > 2 && !suggestions.resources.results.products.length){
            const productBySKU = await this.searchProductBySKU(searchTerm);
            if(productBySKU) suggestions.resources.results.products.push(productBySKU);
          }

         const productLinkList = document.querySelector('.of-footer .of-container .of-navigation .of-group:first-of-type ul').cloneNode(true);
         productLinkList?.querySelector('.of-head')?.remove();

          const searchHistory = await this.getSearchHistory();
          const searchHistoryHTML = searchHistory?.map(term => `
            <li class="recent-searches-list-item">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="SEARCH-DESK" width="40" height="40" viewBox="0 0 40 40" class="icon-search">
              <defs>
                <clipPath id="clip-path_search">
                  <rect id="Rectangle_452" data-name="Rectangle 452" width="20" height="20" transform="translate(280 26)" fill="#233f20"/>
                </clipPath>
              </defs>
              <rect id="Rectangle_451" data-name="Rectangle 451" width="40" height="40" fill="none"/>
              <g id="Mask_Group_3" data-name="Mask Group 3" transform="translate(-270 -16)" clip-path="url(#clip-path_search)">
                <g id="Group_933" data-name="Group 933" transform="translate(280.5 26.5)">
                  <g id="Group_8" data-name="Group 8">
                    <path id="Path_12" data-name="Path 12" d="M19,18.3l-4.5-4.5a8.329,8.329,0,1,0-.7.7L18.3,19ZM1,8.3a7.3,7.3,0,1,1,7.3,7.3A7.341,7.341,0,0,1,1,8.3" fill="#233f20" stroke="#233f20" stroke-width="1"/>
                  </g>
                </g>
              </g>
            </svg>
              <a href="/search?q=${encodeURIComponent(term)}">${term}</a>
            </li>
          `).join('');

          this.predictiveSearchResults.innerHTML = `

          <ul class="collectionsItems searchItems" :class="{ 'active': this.searchHistory?.length > 0}">
            ${searchHistoryHTML}
          </ul>

          <div x-data="{ results: ${JSON.stringify(suggestions.resources.results)?.replace(/"/g, '&quot;')} }" class="search_results" :class="{ 'active': results?.products.length > 0 || results?.collections.length > 0 || results?.pages.length > 0 || results.articles.length > 0 }">
      
              <!-- Collections -->
              <div x-show="results?.collections && results?.collections.length > 0">
                  <div class="collectionsTab">
                      <div class="collectionsHeading">Category</div>
                      <ul class="collectionsItems">
                          <template x-for="collection in results?.collections.slice(0, 5)">
                              <li><a target="_self" x-bind:href="'/' + collection[1].url" x-text="collection[0]"></a></li>
                          </template>
                      </ul>
                  </div>
              </div>
      
              <!-- Pages -->
              <div x-show="results?.pages && results?.pages.length > 0">
                  <div class="pagesTab">
                      <div class="pagesHeading">Pages</div>
                      <ul class="pagesItems">
                          <template x-for="page in results.pages">
                              <li><a target="_self" x-bind:href="'/pages/' + page.url" x-text="page.title"></a></li>
                          </template>
                      </ul>
                  </div>
              </div>
      
              <!-- Articles -->
              <div x-show="results?.articles && results?.articles.length > 0">
                  <div class="articlesTab">
                      <div class="articlesHeading">Articles</div>
                      <ul class="articlesItems">
                          <template x-for="article in results?.articles">
                              <li><a target="_self" x-bind:href="article.url" x-text="article.title"></a></li>
                          </template>
                      </ul>
                  </div>
              </div>
      
              <!-- Products -->
              <div x-show="results.products && results.products.length > 0">
                  <div class="productsTab">
                      <span class="productHeader">Products</span>
                      <div class="productResults">
                          <template x-for="product in results.products.slice(0, 6)">
                              <div class="searchItem">
                                  <a class="searchItemUrl" x-bind:title="product.title" target="_self" x-bind:href="product.url">
                                      <div class="searchItemProductTop">
                                          <div class="searchImgWrap border-radius">
                                              <img class="searchImg border-radius" x-bind:src="product.featured_image.url.replace('.jpg', '_500x.jpg')" x-bind:alt="product.title" width="480" height="480">
                                          </div>
                                      </div>
                                      <div class="searchItemProductBottom">
                                          <div class="searchProductTitle" x-text="product.title"></div>
                                          <div class="searchProductPrice" x-text="'£' + product.price"></div>
                                      </div>
                                  </a>
                              </div>
                          </template>
                      </div>
                  </div>
              </div>
          </div>
          `;

          this.emptySearch.innerHTML = ` 
            <!-- Empty Search -->
                <div x-data="{ results: ${JSON.stringify(suggestions.resources.results)?.replace(/"/g, '&quot;')} }" class="empty_results" :class="{ 'active': results?.products.length < 1 }" x-show="(results.products.length < 1)">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="SEARCH-DESK" width="40" height="40" viewBox="0 0 40 40" class="icon-search">
                  <defs>
                    <clipPath id="clip-path_2">
                      <rect id="Rectangle_452" data-name="Rectangle 452" width="20" height="20" transform="translate(280 26)" fill="#233f20"/>
                    </clipPath>
                  </defs>
                  <rect id="Rectangle_451" data-name="Rectangle 451" width="40" height="40" fill="none"/>
                  <g id="Mask_Group_3" data-name="Mask Group 3" transform="translate(-270 -16)" clip-path="url(#clip-path_2)">
                    <g id="Group_933" data-name="Group 933" transform="translate(280.5 26.5)">
                      <g id="Group_8" data-name="Group 8">
                        <path id="Path_12" data-name="Path 12" d="M19,18.3l-4.5-4.5a8.329,8.329,0,1,0-.7.7L18.3,19ZM1,8.3a7.3,7.3,0,1,1,7.3,7.3A7.341,7.341,0,0,1,1,8.3" fill="#233f20" stroke="#233f20" stroke-width="1"/>
                      </g>
                    </g>
                  </g>
                </svg>
                <p>We couldn't find anything for "${searchTerm}"</p>
                </div>
          `;
          if (productLinkList) this.emptySearch.appendChild(productLinkList);

          this.open();
          if(suggestions) this.predictiveSearchResults.classList.remove('active')
          

        } catch (error) {
        this.close();
        console.error(error);
        }
  }


  open() {
    // this.predictiveSearchResults.style.display = 'block';
    this.predictiveSearchResults.classList.add('active');

  }

  close() {
    this.predictiveSearchResults.classList.remove('active');
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.innerHTML = '';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  async searchCollections (searchTerm) {
    const data = await fetch(`https://houseof-api.herokuapp.com/collections?term=${searchTerm}`)
    const collections = await data.json();
    return collections
  }

  async searchProductBySKU (sku) {
    try {
      const data = await fetch(`https://houseof-api.herokuapp.com/productbysku?term=${sku}`);
      const product = await data.json();
      return product
    } catch (error) {
      console.log(error)
    }
  }

  async searchPages (searchTerm) {
    const data = await fetch(`https://houseof-api.herokuapp.com/pages?term=${searchTerm}`)
    const pages = await data.json();
    return pages
  }

  getSearchHistory() {
    const history = localStorage.getItem('searchHistory');
    return history ? JSON.parse(history) : [];
  }

  updateSearchHistory(term) {
    const history = this.getSearchHistory();
    const index = history?.indexOf(term);
    if (index > -1) {
      history.splice(index, 1); // Remove existing term
    }
    history.unshift(term); // Add term to the beginning
    history.length = Math.min(history.length, 3); // Keep only the last 3 terms
    localStorage.setItem('searchHistory', JSON.stringify(history));
  }

  onEnterPressed(event) {
    const searchTerm = this.input.value.trim();
    if (searchTerm.length) {
      this.updateSearchHistory(searchTerm);
    }
  }
    
}

customElements.define('predictive-search', PredictiveSearch);


